import { Elm } from "./elm/Main.elm";

// Boot the Elm app
const app = Elm.Main.init({
    node: document.getElementById("app"),
    flags: {},
});

app.ports.requestClipboard.subscribe(async function () {
    try {
        const text = await navigator.clipboard.readText();
        app.ports.clipboardReceived.send(text);
    } catch (err) {
        app.ports.clipboardReceived.send("[Error: unable to read clipboard]");
    }
});
